import { forwardRef, ElementType } from 'react'
import classNames from '@/utils/classNames'
import { CommonProps } from '@/@types/common'

interface ContainerProps extends CommonProps {
    asElement?: ElementType
}

const Container = forwardRef((props: ContainerProps, ref) => {
    const { className, children, asElement: Component = 'div', ...rest } = props

    return (
        <Component
            ref={ref}
            className={classNames('mx-auto px-2 md:px-6 lg:px-10 xl:px-2 max-w-screen-xl', className)}
            {...rest}
        >
            {children}
        </Component>
    )
})

Container.displayName = 'Container'

export default Container
